"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ConfirmedBasket = _interopRequireDefault(require("../model/ConfirmedBasket"));
var _CreditCard = _interopRequireDefault(require("../model/CreditCard"));
var _HostedPayment = _interopRequireDefault(require("../model/HostedPayment"));
var _InstoreCashPayment = _interopRequireDefault(require("../model/InstoreCashPayment"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _MobileWallet = _interopRequireDefault(require("../model/MobileWallet"));
var _NoPayment = _interopRequireDefault(require("../model/NoPayment"));
var _OnlineCashPayment = _interopRequireDefault(require("../model/OnlineCashPayment"));
var _Order = _interopRequireDefault(require("../model/Order"));
var _PayOnInvoice = _interopRequireDefault(require("../model/PayOnInvoice"));
var _ServiceBalanceTransfer = _interopRequireDefault(require("../model/ServiceBalanceTransfer"));
var _TokenizedCard = _interopRequireDefault(require("../model/TokenizedCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* ConfirmedBasket service.
* @module api/ConfirmedBasketApi
* @version 3.0
*/
var ConfirmedBasketApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new ConfirmedBasketApi. 
  * @alias module:api/ConfirmedBasketApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ConfirmedBasketApi(apiClient) {
    _classCallCheck(this, ConfirmedBasketApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create a Credit Card Payment Method
   * Creates a Credit Card Payment Method for the Confirmed Basket.<br>When the PUT on the Credit Card Payment Method happens the SSB will process the basket.<br>
   * @param {Number} userId User ID the basket is for
   * @param {Number} basketId Basket ID the payment is for
   * @param {Object} opts Optional parameters
   * @param {String} [gateway = '')] Gateway
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreditCard} and HTTP response
   */
  return _createClass(ConfirmedBasketApi, [{
    key: "createCreditCardPaymentMthdWithHttpInfo",
    value: function createCreditCardPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createCreditCardPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createCreditCardPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _CreditCard["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/creditcards', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Credit Card Payment Method
     * Creates a Credit Card Payment Method for the Confirmed Basket.<br>When the PUT on the Credit Card Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreditCard}
     */
  }, {
    key: "createCreditCardPaymentMthd",
    value: function createCreditCardPaymentMthd(userId, basketId, opts) {
      return this.createCreditCardPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a Hosted Payment Method
     * Creates a Hosted Payment Method for the Confirmed Basket and returns the details for the hosted gateway.<br>An example of this is a 3-party card payment system. In this instance a URL will be returned on which a customer can make a payment. It is not possible to PUT on this Payment Method.<br>A webhook (referencing the baskekRefID trigged by the hosted payment system) is used to modify the payment and then process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HostedPayment} and HTTP response
     */
  }, {
    key: "createHostedPaymentMthdWithHttpInfo",
    value: function createHostedPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createHostedPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createHostedPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _HostedPayment["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/hostedpayment', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Hosted Payment Method
     * Creates a Hosted Payment Method for the Confirmed Basket and returns the details for the hosted gateway.<br>An example of this is a 3-party card payment system. In this instance a URL will be returned on which a customer can make a payment. It is not possible to PUT on this Payment Method.<br>A webhook (referencing the baskekRefID trigged by the hosted payment system) is used to modify the payment and then process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HostedPayment}
     */
  }, {
    key: "createHostedPaymentMthd",
    value: function createHostedPaymentMthd(userId, basketId, opts) {
      return this.createHostedPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create an Instore Cash Payment Method
     * Creates an Instore Cash Payment Method for the Confirmed Basket with a reference.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InstoreCashPayment} and HTTP response
     */
  }, {
    key: "createInstoreCashPaymentMthdWithHttpInfo",
    value: function createInstoreCashPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createInstoreCashPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createInstoreCashPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _InstoreCashPayment["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/instorecashpayments', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create an Instore Cash Payment Method
     * Creates an Instore Cash Payment Method for the Confirmed Basket with a reference.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InstoreCashPayment}
     */
  }, {
    key: "createInstoreCashPaymentMthd",
    value: function createInstoreCashPaymentMthd(userId, basketId, opts) {
      return this.createInstoreCashPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create Mobile Wallet Payment Method.
     * Creates a Mobile Wallet Payment Method for the Confirmed Basket.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confirmed Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MobileWallet} and HTTP response
     */
  }, {
    key: "createMobileWalletPaymentMthdWithHttpInfo",
    value: function createMobileWalletPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createMobileWalletPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createMobileWalletPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _MobileWallet["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/mobilewallets', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create Mobile Wallet Payment Method.
     * Creates a Mobile Wallet Payment Method for the Confirmed Basket.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confirmed Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MobileWallet}
     */
  }, {
    key: "createMobileWalletPaymentMthd",
    value: function createMobileWalletPaymentMthd(userId, basketId, opts) {
      return this.createMobileWalletPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a No Payment type of Payment Method.
     * Creates a No Payment type of Payment Method for the Confirmed Basket.<br>This payment method will only ever process successfully when there is no payment to be made for a basket (i.e. the upfront cost is 0) When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/NoPayment} and HTTP response
     */
  }, {
    key: "createNoPaymentPaymentMthdWithHttpInfo",
    value: function createNoPaymentPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createNoPaymentPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createNoPaymentPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _NoPayment["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/nopayment', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a No Payment type of Payment Method.
     * Creates a No Payment type of Payment Method for the Confirmed Basket.<br>This payment method will only ever process successfully when there is no payment to be made for a basket (i.e. the upfront cost is 0) When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/NoPayment}
     */
  }, {
    key: "createNoPaymentPaymentMthd",
    value: function createNoPaymentPaymentMthd(userId, basketId, opts) {
      return this.createNoPaymentPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create an Online Cash Payment Method.
     * Creates an online Cash Payment Method for the Confirmed Basket with a reference.<br>A webhook (referencing the baskekRefID is triggered by the cash collection system) is used to modify the payment and then process the basket.<br>After this the basket will remain in a pending state until the cash payment response has been received from the relevant system<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OnlineCashPayment} and HTTP response
     */
  }, {
    key: "createOnlineCashPaymentMthdWithHttpInfo",
    value: function createOnlineCashPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createOnlineCashPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createOnlineCashPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OnlineCashPayment["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/onlinecashpayments', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create an Online Cash Payment Method.
     * Creates an online Cash Payment Method for the Confirmed Basket with a reference.<br>A webhook (referencing the baskekRefID is triggered by the cash collection system) is used to modify the payment and then process the basket.<br>After this the basket will remain in a pending state until the cash payment response has been received from the relevant system<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OnlineCashPayment}
     */
  }, {
    key: "createOnlineCashPaymentMthd",
    value: function createOnlineCashPaymentMthd(userId, basketId, opts) {
      return this.createOnlineCashPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a Pay On Invoice Payment Method.
     * Creates a Pay On Invoice Payment Method for the Confirmed Basket.<br>This represents a customer wishing to add the charge to their postpaid bill (invoice)<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PayOnInvoice} and HTTP response
     */
  }, {
    key: "createPayOnInvoicePaymentMthdWithHttpInfo",
    value: function createPayOnInvoicePaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createPayOnInvoicePaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createPayOnInvoicePaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _PayOnInvoice["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/payoninvoice', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Pay On Invoice Payment Method.
     * Creates a Pay On Invoice Payment Method for the Confirmed Basket.<br>This represents a customer wishing to add the charge to their postpaid bill (invoice)<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PayOnInvoice}
     */
  }, {
    key: "createPayOnInvoicePaymentMthd",
    value: function createPayOnInvoicePaymentMthd(userId, basketId, opts) {
      return this.createPayOnInvoicePaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create Service Balance Transfer Payment Method.
     * Creates a Service Balance Transfer Payment Method for a Confirmed Basket.<br>This will attempt to take a payment from the Monetary Balance of the customer on the confirmed basket. When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ServiceBalanceTransfer} and HTTP response
     */
  }, {
    key: "createServiceBalanceTransferPaymentMthdWithHttpInfo",
    value: function createServiceBalanceTransferPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createServiceBalanceTransferPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createServiceBalanceTransferPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _ServiceBalanceTransfer["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/servicebalancetransfers', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create Service Balance Transfer Payment Method.
     * Creates a Service Balance Transfer Payment Method for a Confirmed Basket.<br>This will attempt to take a payment from the Monetary Balance of the customer on the confirmed basket. When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ServiceBalanceTransfer}
     */
  }, {
    key: "createServiceBalanceTransferPaymentMthd",
    value: function createServiceBalanceTransferPaymentMthd(userId, basketId, opts) {
      return this.createServiceBalanceTransferPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a Tokenized Card Payment Method.
     * Creates a Tokenized Card Payment Method for the Confirmed Basket with a reference. This payment method uses a pre-tokenized card which is stored in an external system, with the token being used to take the payment.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} [gateway = '')] Gateway
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TokenizedCard} and HTTP response
     */
  }, {
    key: "createTokenizedCardPaymentMthdWithHttpInfo",
    value: function createTokenizedCardPaymentMthdWithHttpInfo(userId, basketId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createTokenizedCardPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling createTokenizedCardPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {
        'gateway': opts['gateway']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _TokenizedCard["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/tokenizedcards', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Tokenized Card Payment Method.
     * Creates a Tokenized Card Payment Method for the Confirmed Basket with a reference. This payment method uses a pre-tokenized card which is stored in an external system, with the token being used to take the payment.<br>When the PUT on the Payment Method happens the SSB will process the basket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID the payment is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.gateway Gateway (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TokenizedCard}
     */
  }, {
    key: "createTokenizedCardPaymentMthd",
    value: function createTokenizedCardPaymentMthd(userId, basketId, opts) {
      return this.createTokenizedCardPaymentMthdWithHttpInfo(userId, basketId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Confirmed Basket.
     * Get a Confirmed Basket<br>A Confirmed Basket cannot have its contents modified.<br>Only a payment method can be attached.<br>Once the payment is PUT onto the Confirmed Basket, it is transacted.<br>If the payment is successful then an Order is created.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConfirmedBasket} and HTTP response
     */
  }, {
    key: "getConfirmedBasketWithHttpInfo",
    value: function getConfirmedBasketWithHttpInfo(userId, basketId) {
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getConfirmedBasket");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling getConfirmedBasket");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _ConfirmedBasket["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Confirmed Basket.
     * Get a Confirmed Basket<br>A Confirmed Basket cannot have its contents modified.<br>Only a payment method can be attached.<br>Once the payment is PUT onto the Confirmed Basket, it is transacted.<br>If the payment is successful then an Order is created.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConfirmedBasket}
     */
  }, {
    key: "getConfirmedBasket",
    value: function getConfirmedBasket(userId, basketId) {
      return this.getConfirmedBasketWithHttpInfo(userId, basketId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Confirmed Baskets
     * Returns a list of Confirmed Baskets which the User has.<br>Can be filtered by Confirmed Basket status (e.g. awaiting-cash-payment)<br>
     * @param {Number} userId User ID the basket is for
     * @param {Object} opts Optional parameters
     * @param {String} [status = 'awaiting-cash-payment')] Status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ConfirmedBasket>} and HTTP response
     */
  }, {
    key: "getConfirmedBasketsWithHttpInfo",
    value: function getConfirmedBasketsWithHttpInfo(userId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getConfirmedBaskets");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_ConfirmedBasket["default"]];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Confirmed Baskets
     * Returns a list of Confirmed Baskets which the User has.<br>Can be filtered by Confirmed Basket status (e.g. awaiting-cash-payment)<br>
     * @param {Number} userId User ID the basket is for
     * @param {Object} opts Optional parameters
     * @param {String} opts.status Status (default to 'awaiting-cash-payment')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ConfirmedBasket>}
     */
  }, {
    key: "getConfirmedBaskets",
    value: function getConfirmedBaskets(userId, opts) {
      return this.getConfirmedBasketsWithHttpInfo(userId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Update confirmed basket
     * Updates a confirmed basket.<br>This is not used to submit the Confirmed Basket, that must be done through creating and submitting a Payment Method
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confimed Basket ID
     * @param {module:model/ConfirmedBasket} confirmedBasket A confirmed basket details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyConfirmedBasketWithHttpInfo",
    value: function modifyConfirmedBasketWithHttpInfo(userId, basketId, confirmedBasket) {
      var postBody = confirmedBasket;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyConfirmedBasket");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyConfirmedBasket");
      }
      // verify the required parameter 'confirmedBasket' is set
      if (confirmedBasket === undefined || confirmedBasket === null) {
        throw new Error("Missing the required parameter 'confirmedBasket' when calling modifyConfirmedBasket");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Update confirmed basket
     * Updates a confirmed basket.<br>This is not used to submit the Confirmed Basket, that must be done through creating and submitting a Payment Method
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confimed Basket ID
     * @param {module:model/ConfirmedBasket} confirmedBasket A confirmed basket details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyConfirmedBasket",
    value: function modifyConfirmedBasket(userId, basketId, confirmedBasket) {
      return this.modifyConfirmedBasketWithHttpInfo(userId, basketId, confirmedBasket).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take Credit Card Payment
     * Takes the Credit Card payment on the Confirmed Basket.<br>The details of the Credit Card are encapsulated in the body of the request.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains the details of the reason for failure<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/CreditCard} creditCard Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyCreditCardPaymentMthdWithHttpInfo",
    value: function modifyCreditCardPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, creditCard) {
      var postBody = creditCard;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyCreditCardPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyCreditCardPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyCreditCardPaymentMthd");
      }
      // verify the required parameter 'creditCard' is set
      if (creditCard === undefined || creditCard === null) {
        throw new Error("Missing the required parameter 'creditCard' when calling modifyCreditCardPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/creditcards/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take Credit Card Payment
     * Takes the Credit Card payment on the Confirmed Basket.<br>The details of the Credit Card are encapsulated in the body of the request.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains the details of the reason for failure<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/CreditCard} creditCard Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyCreditCardPaymentMthd",
    value: function modifyCreditCardPaymentMthd(userId, basketId, paymentmethodId, creditCard) {
      return this.modifyCreditCardPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, creditCard).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take an Instore Cash Payment
     * Confirms that the Cash Payment has been made.<br>The details of the Cash Payment are encapsulated in the request payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/InstoreCashPayment} instoreCashPayment Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyInstoreCashPaymentMthdWithHttpInfo",
    value: function modifyInstoreCashPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, instoreCashPayment) {
      var postBody = instoreCashPayment;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyInstoreCashPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyInstoreCashPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyInstoreCashPaymentMthd");
      }
      // verify the required parameter 'instoreCashPayment' is set
      if (instoreCashPayment === undefined || instoreCashPayment === null) {
        throw new Error("Missing the required parameter 'instoreCashPayment' when calling modifyInstoreCashPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/instorecashpayments/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take an Instore Cash Payment
     * Confirms that the Cash Payment has been made.<br>The details of the Cash Payment are encapsulated in the request payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/InstoreCashPayment} instoreCashPayment Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyInstoreCashPaymentMthd",
    value: function modifyInstoreCashPaymentMthd(userId, basketId, paymentmethodId, instoreCashPayment) {
      return this.modifyInstoreCashPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, instoreCashPayment).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take Mobile Wallet Payment
     * Takes the Mobile Wallet Payment on the Confirmed Basket.<br>The details of the Mobile Wallet payment are encapsulated in the body of the request.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains details of the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confirmed Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/MobileWallet} mobileWallet Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyMobileWalletPaymentMthdWithHttpInfo",
    value: function modifyMobileWalletPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, mobileWallet) {
      var postBody = mobileWallet;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyMobileWalletPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyMobileWalletPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyMobileWalletPaymentMthd");
      }
      // verify the required parameter 'mobileWallet' is set
      if (mobileWallet === undefined || mobileWallet === null) {
        throw new Error("Missing the required parameter 'mobileWallet' when calling modifyMobileWalletPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/mobilewallets/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take Mobile Wallet Payment
     * Takes the Mobile Wallet Payment on the Confirmed Basket.<br>The details of the Mobile Wallet payment are encapsulated in the body of the request.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains details of the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Confirmed Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/MobileWallet} mobileWallet Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyMobileWalletPaymentMthd",
    value: function modifyMobileWalletPaymentMthd(userId, basketId, paymentmethodId, mobileWallet) {
      return this.modifyMobileWalletPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, mobileWallet).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Submit Confirmed Basket with No Payment
     * Submits the Confirmed Basket without a payment being taken.<br>This cannot succeed if the upfront cost of the Confirmed Basket is not 0<br>The details of the No Payment are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/NoPayment} noPayment Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyNoPaymentPaymentMthdWithHttpInfo",
    value: function modifyNoPaymentPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, noPayment) {
      var postBody = noPayment;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyNoPaymentPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyNoPaymentPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyNoPaymentPaymentMthd");
      }
      // verify the required parameter 'noPayment' is set
      if (noPayment === undefined || noPayment === null) {
        throw new Error("Missing the required parameter 'noPayment' when calling modifyNoPaymentPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/nopayment/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Submit Confirmed Basket with No Payment
     * Submits the Confirmed Basket without a payment being taken.<br>This cannot succeed if the upfront cost of the Confirmed Basket is not 0<br>The details of the No Payment are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/NoPayment} noPayment Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyNoPaymentPaymentMthd",
    value: function modifyNoPaymentPaymentMthd(userId, basketId, paymentmethodId, noPayment) {
      return this.modifyNoPaymentPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, noPayment).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take Pay On Invoice Payment
     * Takes a Pay On Invoice payment on the Confirmed Basket, adding the cost of the Confirmed Basket to the Customer’s Invoice.<br>The details of the Pay On Invoice are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/PayOnInvoice} payOnInvoice Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyPayOnInvoicePaymentMthdWithHttpInfo",
    value: function modifyPayOnInvoicePaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, payOnInvoice) {
      var postBody = payOnInvoice;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyPayOnInvoicePaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyPayOnInvoicePaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyPayOnInvoicePaymentMthd");
      }
      // verify the required parameter 'payOnInvoice' is set
      if (payOnInvoice === undefined || payOnInvoice === null) {
        throw new Error("Missing the required parameter 'payOnInvoice' when calling modifyPayOnInvoicePaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/payoninvoice/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take Pay On Invoice Payment
     * Takes a Pay On Invoice payment on the Confirmed Basket, adding the cost of the Confirmed Basket to the Customer’s Invoice.<br>The details of the Pay On Invoice are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/PayOnInvoice} payOnInvoice Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyPayOnInvoicePaymentMthd",
    value: function modifyPayOnInvoicePaymentMthd(userId, basketId, paymentmethodId, payOnInvoice) {
      return this.modifyPayOnInvoicePaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, payOnInvoice).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take Service Balance Transfer Payment
     * Takes payment for a Confirmed Basket using a Service Balance Transfer.<br>The details (which Service, authorization etc) are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains details of the reason for failure.<br>The User must be able to access the Service which they are using the Balance of.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/ServiceBalanceTransfer} serviceBalanceTransfer Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyServiceBalanceTransferPaymentMthdWithHttpInfo",
    value: function modifyServiceBalanceTransferPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, serviceBalanceTransfer) {
      var postBody = serviceBalanceTransfer;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyServiceBalanceTransferPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyServiceBalanceTransferPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyServiceBalanceTransferPaymentMthd");
      }
      // verify the required parameter 'serviceBalanceTransfer' is set
      if (serviceBalanceTransfer === undefined || serviceBalanceTransfer === null) {
        throw new Error("Missing the required parameter 'serviceBalanceTransfer' when calling modifyServiceBalanceTransferPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/servicebalancetransfers/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take Service Balance Transfer Payment
     * Takes payment for a Confirmed Basket using a Service Balance Transfer.<br>The details (which Service, authorization etc) are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response contains details of the reason for failure.<br>The User must be able to access the Service which they are using the Balance of.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/ServiceBalanceTransfer} serviceBalanceTransfer Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyServiceBalanceTransferPaymentMthd",
    value: function modifyServiceBalanceTransferPaymentMthd(userId, basketId, paymentmethodId, serviceBalanceTransfer) {
      return this.modifyServiceBalanceTransferPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, serviceBalanceTransfer).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Take a Tokenized Card Payment
     * Takes the payment using a Tokenized Card.<br>The details of the Tokenized Card are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/TokenizedCard} tokenizedCard Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
     */
  }, {
    key: "modifyTokenizedCardPaymentMthdWithHttpInfo",
    value: function modifyTokenizedCardPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, tokenizedCard) {
      var postBody = tokenizedCard;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyTokenizedCardPaymentMthd");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyTokenizedCardPaymentMthd");
      }
      // verify the required parameter 'paymentmethodId' is set
      if (paymentmethodId === undefined || paymentmethodId === null) {
        throw new Error("Missing the required parameter 'paymentmethodId' when calling modifyTokenizedCardPaymentMthd");
      }
      // verify the required parameter 'tokenizedCard' is set
      if (tokenizedCard === undefined || tokenizedCard === null) {
        throw new Error("Missing the required parameter 'tokenizedCard' when calling modifyTokenizedCardPaymentMthd");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId,
        'paymentmethodId': paymentmethodId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/users/{userId}/confirmedbaskets/{basketId}/paymentmethods/tokenizedcardpayments/{paymentmethodId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Take a Tokenized Card Payment
     * Takes the payment using a Tokenized Card.<br>The details of the Tokenized Card are encapsulated in the payload.<br>If the payment is successful then an Order is created.<br>Otherwise the response details the reason for failure.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {Number} paymentmethodId Payment ID
     * @param {module:model/TokenizedCard} tokenizedCard Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "modifyTokenizedCardPaymentMthd",
    value: function modifyTokenizedCardPaymentMthd(userId, basketId, paymentmethodId, tokenizedCard) {
      return this.modifyTokenizedCardPaymentMthdWithHttpInfo(userId, basketId, paymentmethodId, tokenizedCard).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();